export default __webpack_public_path__ + "static/media/D_wdt_c_cap_4.5c1b743e.mp3";